"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var KeyboardShortcutIndicator = function KeyboardShortcutIndicator(_ref) {
  var _cx;

  var className = _ref.className,
      label = _ref.label,
      _onClick = _ref.onClick,
      reverse = _ref.reverse,
      shortcut = _ref.shortcut,
      style = _ref.style,
      tooltip = _ref.tooltip;

  if (!shortcut) {
    return null;
  } // Put string (single-key shortcut) into array.


  if (typeof shortcut === 'string') {
    shortcut = [shortcut];
  }

  var isUnicode = function isUnicode(char) {
    if (char.length > 1) {
      return false;
    }

    if (char.charCodeAt(0) > 255) {
      return true;
    }

    return false;
  };

  var renderKey = function renderKey(shortcutKey) {
    return _react.default.createElement("div", {
      className: (0, _classnames.default)({
        'center-all monospace border font-size-1': true,
        'bg-grey-xxl grey': !reverse,
        'bg-grey-d grey-l': reverse
      }),
      style: {
        border: "1px solid",
        borderColor: reverse ? 'rgba(255,255,255,.1)' : 'rgba(0,0,0,.1)',
        borderBottomWidth: '2px',
        borderRadius: '.2em',
        display: 'inline-flex',
        height: '1em',
        marginRight: 2,
        minWidth: '1em',
        padding: 2,
        position: 'relative',
        userSelect: 'none'
      }
    }, isUnicode(shortcutKey) ? _react.default.createElement("span", {
      className: "absolute font-size-3",
      style: {
        top: -3
      }
    }, shortcutKey) : _react.default.createElement("span", null, shortcutKey));
  };

  var schematic = _react.default.createElement("div", {
    style: {
      display: 'inline-flex',
      flexDirection: 'row'
    }
  }, shortcut.map(function (shortcutKey, s) {
    return _react.default.createElement("div", {
      key: s
    }, renderKey(shortcutKey));
  }));

  var html = _react.default.createElement("div", {
    className: (0, _classnames.default)((_cx = {}, (0, _defineProperty2.default)(_cx, className, className), (0, _defineProperty2.default)(_cx, 'cursor-pointer', _onClick || tooltip), _cx)),
    onClick: function onClick() {
      return _onClick && _onClick();
    },
    style: style
  }, _react.default.createElement("div", {
    className: "inline-block text-center"
  }, schematic, label && _react.default.createElement("div", {
    className: "font-size-1 bold",
    style: {
      marginTop: 3
    }
  }, label)));

  if (tooltip) {
    var tooltipHtml = _react.default.createElement("div", {
      className: "padding-1"
    }, "Press ", schematic, " to ", tooltip, ".");
  }

  return html;
};

KeyboardShortcutIndicator.defaultProps = {
  label: null,
  onClick: null,
  reverse: false,
  shortcut: null,
  tooltip: null
};
var _default = KeyboardShortcutIndicator;
exports.default = _default;